import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface ConsentBannerProps {
  isVisible: boolean;
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onCustomize: () => void;
}

const ConsentBanner: React.FC<ConsentBannerProps> = ({
  isVisible,
  onAcceptAll,
  onRejectAll,
  onCustomize,
}) => {
  const { t } = useTranslation('privacy');

  if (!isVisible) {
    return null;
  }

  return (
    <div className="privacy-banner" role="region" aria-live="polite">
      <div className="container privacy-banner__inner">
        <div className="privacy-banner__content">
          <h2 className="privacy-banner__title">{t('banner.title')}</h2>
          <p className="privacy-banner__description">{t('banner.description')}</p>
          <p className="privacy-banner__links">
            <Trans
              i18nKey="banner.links"
              ns="privacy"
              components={{
                privacyLink: (
                  <Link
                    key="privacy-link"
                    to="/legal/privacy-policy"
                    className="privacy-banner__link"
                  />
                ),
                cookiesLink: (
                  <Link
                    key="cookies-link"
                    to="/legal/cookie-policy"
                    className="privacy-banner__link"
                  />
                ),
              }}
            />
          </p>
        </div>
        <div className="privacy-banner__actions" role="group" aria-label={t('banner.actionsLabel')}>
          <button
            type="button"
            className="btn btn-primary privacy-banner__button"
            onClick={onAcceptAll}
          >
            {t('banner.acceptAll')}
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary privacy-banner__button"
            onClick={onRejectAll}
          >
            {t('banner.rejectAll')}
          </button>
          <button
            type="button"
            className="btn btn-link privacy-banner__button privacy-banner__button--customize"
            onClick={onCustomize}
          >
            {t('banner.customize')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
